import React, { useEffect, useState } from 'react';

import Picker from 'emoji-picker-react';

import { useField } from 'formik';

import { Button } from '../../../../../Common';

import './index.scss';

const MutateTasksListIcon = ({ name, ...props }) => {
  const [field, , fieldHelper] = useField(name);
  const [icon, setIcon] = useState(field.value);
  const [emojiToggled, setEmojiToggled] = useState(false);

  const onEmojiClick = (event, emojiObject) => {
    setIcon(emojiObject.emoji);
    setEmojiToggled(false);
  };

  const removeIcon = () => {
    fieldHelper.setValue('');
  };

  useEffect(() => {
    fieldHelper.setValue(icon);
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [icon]);

  return (
    <div className="mutate-tasks-list-icon" {...props}>
      <h5>Icon</h5>
      <div className="mutate-tasks-list-icon-flex">
        <Button type="button" sm onClick={() => setEmojiToggled(!emojiToggled)}>
          Select Icon
        </Button>
        {field.value && <p onClick={() => removeIcon()}>{field.value}</p>}
      </div>
      {emojiToggled && <Picker onEmojiClick={onEmojiClick} />}
    </div>
  );
};

export default MutateTasksListIcon;
